export const DESKTOP_MIN_WIDTH = 1200;
export const DESKTOP_HD_MIN_WIDTH = 1280;
export const TABLET_MIN_WIDTH = 768;
export const MINIFIED_CALL_WIDTH = '259px';
export const MINIFIED_CALL_HEIGHT = '230px';
